import React from 'react';
import { Button, Input } from '@appkit4/react-components';
import { UploadValidationRule } from '../../api/generated/models';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import useLocale from '../../locale/useLocale';

interface SuperAdminCreateBusinessRuleFormProps {
    submitFunc: (values: FormValues) => void;
    existingRule: UploadValidationRule;
}

export interface FormValues {
    name: string;
    rules: string;
}

const SuperAdminCreateBusinessRuleForm = (
    props: SuperAdminCreateBusinessRuleFormProps
) => {
    const { l } = useLocale();

    const NewBusinessRuleSchema = Yup.object({
        name: Yup.string()
            .trim()
            .max(50, l('_pleaseEnterFewerCharacters'))
            .required(l('_pleaseEnterABusinessRuleName')),
        rules: Yup.string()
            .trim()
            .max(200, l('_pleaseEnterFewerCharacters'))
            .required(l('_pleaseEnterABusinessRule')),
    });

    return (
        <Formik
            initialValues={{
                name: props.existingRule.name || '',
                rules: props.existingRule.rules || '',
            }}
            validationSchema={NewBusinessRuleSchema}
            onSubmit={(values) => props.submitFunc(values)}
        >
            {({
                errors,
                touched,
                setFieldTouched,
                setFieldValue,
                validateField,
                values,
            }) => (
                <Form>
                    <Input
                        type="text"
                        title={l('_businessRuleName')}
                        placeholder={l('_businessRuleName')}
                        value={values.name}
                        required
                        onChange={(value: string) => {
                            setFieldTouched('name');
                            validateField('name');
                            setFieldValue('name', value);
                        }}
                    />
                    {touched.name && errors.name && (
                        <div className="ap-text-states-error-04">
                            {errors.name}
                        </div>
                    )}
                    <Input
                        type="text"
                        className="mt-3"
                        title={l('_businessRules')}
                        placeholder="{rule}|{rule}|{rule}..."
                        value={values.rules}
                        required
                        onChange={(value: string) => {
                            setFieldTouched('rules');
                            validateField('rules');
                            setFieldValue('rules', value);
                        }}
                    />
                    {touched.rules && errors.rules && (
                        <div className="ap-text-states-error-04">
                            {errors.rules}
                        </div>
                    )}
                    <Button className="ms-auto mt-3" type="submit">
                        {l('_editBusinessRule')}
                    </Button>
                </Form>
            )}
        </Formik>
    );
};

export default SuperAdminCreateBusinessRuleForm;
